import React from 'react';
import { VerificationService, getOptions, ProgramTheme } from '@sheerid/jslib';

interface LogoProps {
    verificationService: VerificationService;
}

const LogoComponent = ({ verificationService }: LogoProps) => {
    const getLogoUrl = (programTheme: ProgramTheme): ProgramTheme['logoUrl'] => {
        const options = getOptions();
        return options.hasOwnProperty('logoUrl') ? options.logoUrl : programTheme.logoUrl;
    };
    const logoUrl = getLogoUrl(verificationService.programTheme);


    if (logoUrl) {
        return (
            <div className="sid-logo sid-l-space-top-md">
                <img
                    className="sid-logo__img"
                    alt="Princess Cruises Logo"
                    src={logoUrl}
                />
            </div>
        );
    }
    return null;
};

export { LogoComponent };
